
import { LanguageContext } from "../components/layout/layout"
import baseLoc from './loc/base.json';
import { useContext } from "react"

export const useLoc = (lang?: string) => {

    if (!lang) {
        const [langFromContext] = useContext(LanguageContext)
        lang = langFromContext
    }

    const loc = (key: string) => {
        return baseLoc[key] as string;
    }
    return loc;
}

export const locExport = (lang?: string) => {
    return baseLoc;
}